<script setup lang="ts">
const props = defineProps<{
  vacancy: BaseVacancy
}>()

const { t } = useI18n({
  useScope: 'local',
})

// TODO: refactor using the included contactPerson in fetchVacancy.
// in stagedoos this works, not sure about volunteerly yet.
const partialUser = computed(() => ({
  id: props.vacancy.contactPersonId,
  firstName: props.vacancy.contactPersonFirstName,
  lastName: props.vacancy.contactPersonLastName,
  avatarUrl: props.vacancy.contactPersonAvatarUrl,
}))

const { isCenterAdmin } = useCurrentOrganizationRoles()
const showUserLink = isCenterAdmin

const name = `${props.vacancy.contactPersonFirstName} ${props.vacancy.contactPersonLastName}`
const tooltip = t('tooltip', { name })

</script>

<template>
  <SidebarCard
    v-if="vacancy.contactPersonId"
    :title="$t('vacancy.attributes.contactPerson')"
  >
    <div class="flex flex-col gap-y-4">
      <NuxtLink
        v-if="showUserLink"
        :to="`/users/${partialUser.id}`"
        class="flex items-center gap-x-2"
      >
        <UserAvatar
          :user="partialUser"
          :data-nui-tooltip="tooltip"
        />
        <span>{{ name }}</span>
      </NuxtLink>

      <div v-else class="flex items-center gap-x-2">
        <UserAvatar
          :user="partialUser"
          :data-nui-tooltip="tooltip"
        />
        <span>{{ name }}</span>
      </div>

      <VacancyDetailsPhoneCallButton v-if="vacancy.contactPersonPhoneNumber" :phone-number="vacancy.contactPersonPhoneNumber" />

      <StartConversationButton
        :user="partialUser"
        :subject="`Vraag over '${vacancy.title}'`"
        color="default"
        class="w-full"
      >
        <Icon name="ph:chat-circle-duotone" class="size-4" />
        <span>{{ t('askQuestion') }}</span>
      </StartConversationButton>
    </div>
  </SidebarCard>
</template>

<i18n lang="json">
{
  "en": {
    "tooltip": "{name} is the contact person",
    "askQuestion": "Ask a question"
  },
  "nl": {
    "tooltip": "{name} is de contactpersoon",
    "askQuestion": "Stel een vraag"
  }
}
</i18n>
